import {
	ExclamationTriangleIcon,
	InformationCircleIcon,
} from '@heroicons/react/24/outline';
import clsx from 'clsx';

import type { SystemNotificationV1 } from '@/shared/api';

interface AlertContentProps {
	alert: SystemNotificationV1;
}

export const AlertContent = ({ alert }: AlertContentProps) => {
	return (
		<div
			className={clsx('rounded-lg p-5', {
				'border border-yellow bg-yellow/10': alert.level === 'warning',
				'border border-red bg-red-light': alert.level === 'error',
				'border border-indigo bg-indigo/10':
					alert.level === 'info' || alert.level === 'advertisement',
			})}
		>
			<div
				className={clsx('mb-3 flex items-center gap-2', {
					'text-yellow': alert.level === 'warning',
					'text-red': alert.level === 'error',
					'text-indigo':
						alert.level === 'info' || alert.level === 'advertisement',
				})}
			>
				{alert.level === 'error' ? (
					<ExclamationTriangleIcon className="size-6 flex-shrink-0" />
				) : (
					<InformationCircleIcon className="size-6 flex-shrink-0" />
				)}
				<h3 className="text-lg font-semibold">
					{alert.level === 'advertisement' ? alert.widgetTitle : alert.title}
				</h3>
			</div>
			<p className="text-base text-gray-2">{alert.description}</p>
		</div>
	);
};
